import styled from 'styled-components';
import { OfferStyled } from '../OfferStyled';
import { rem } from 'polished';

export const OfferStyledOV = styled(OfferStyled)`
    .offer {
        svg {
            margin-top: 0 !important;
            //border: 1px solid ${({ theme }) => theme.colors.grey21};
            border-radius: 50%;
            height: ${rem('22px')};
            width: ${rem('22px')};
          
            g {
                circle {
                }
                path {
                    fill: ${({ theme }) => theme.colors.grey21} !important;
                }
            }

            path {
				fill: ${({ theme }) => theme.colors.black} !important;
            }
        }
    }
`;
